import Status from 'clarks/components/ivu-table/status' 

let forms = {
   addRole: {
      icon: 'fa fa-user-tag',
      title: 'Add Role',
      subtitle: 'Provide Role Details',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12 col-lg-6', model: 'code',
            validation: 'required|min:3|max:70', label: 'Code',
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-lg-6', model: 'name',
            validation: 'required|min:3|max:150', label: 'Name',
         },
      ]
   },
   editRole: {
      icon: 'fa fa-user-tag',
      title: 'Edit Role',
      subtitle: 'Edit Role and Permissions',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12', model: 'name',
            validation: 'required|min:3|max:150', label: 'Name',
         },
      ]
   },
}

let tables = {
   roles: {
      props: {
         icon: 'fa fa-user-tie',
         title: 'Roles',
         border: true,
         'max-height': 500,
         'show-summary': false,
         search_fields: ["status", "name"],
         columns: [
            { type: 'selection', width: 60, align: 'center'},
            { type: 'index', width: 60, align: 'center'},
            { title: "Code", key: "code"},   
            { title: "Name", key: "name"},   
            { 
               title: "Status", 
               key: "status", 
               align: 'center',
               width: 180,
               render: (h, params) => {
                  return h(Status, {
                     props: {
                        status: params.row.status
                     }
                  });
               },
               filters: [
                  {
                     label: "Created",
                     value: 1
                  },
                  {
                     label: "Updated",
                     value: 2
                  },
                  {
                     label: "Pending Create Verification",
                     value: 3
                  },
                  {
                     label: "Pending Update Verification",
                     value: 4
                  },
                  {
                     label: "Pending Delete Verification",
                     value: 5
                  }
               ],
               filterMultiple: true,
               filterMethod(value, row) {
                  switch(value){
                     case 1: return row.status === 'created';
                     case 2: return row.status === 'updated';
                     case 3: return row.status === 'create_pending';
                     case 4: return row.status === 'update_pending';
                     case 5: return row.status === 'delete_pending';
                  }
               }
            },
         ],
         actions: [
            { type: 'menu', title: 'Edit', event: 'role:edit', icon: 'fa-edit', allow_multiple: false },
            { type: 'menu', title: 'Delete', event: 'role:delete', icon: 'fa-trash-alt', allow_multiple: true },
         ]
      },
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}